// extracted by mini-css-extract-plugin
module.exports = {"root":"OrgSwitch_root__3j9G0"};